import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpHeaders, HttpParams, HttpClient, HttpBackend
} from '@angular/common/http';
import {Injectable, inject} from '@angular/core';
import { Router } from '@angular/router';
import {Observable, catchError, switchMap, throwError, tap, map, take} from 'rxjs';
import { AuthService } from '../../login/data-access/auth.service';
import {SystemManagementService} from "../../admin/data-access/system-management.service";
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenInjectorInterceptor implements HttpInterceptor {
  router = inject(Router);
  authService = inject(AuthService);
  systemService = inject(SystemManagementService)

  private rawHttp: HttpClient;

  constructor(private backend: HttpBackend) {
    // This instance bypasses all interceptors
    this.rawHttp = new HttpClient(backend);
  }
intercept(
  req: HttpRequest<any>,
  next: HttpHandler
): Observable<HttpEvent<any>> {
  // Skip interceptor for S3 URLs
  if (req.url.includes('s3.') || req.url.includes('amazonaws.com')) {
    return next.handle(req);
  }

  return this.authService.token$.pipe(
    take(1),
    switchMap((access_token) => {
      if (!access_token && !req.url.includes('/organization/branding/get') && !req.url.includes('amazoncognito.com/oauth2/token')) {
        this.router.navigate(['/login']);
        return throwError(() => new Error('No token'));
      }

      return next.handle(this.checkAuth(req, access_token)).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            return this.authService.getNewAccessToken().pipe(
              switchMap(newToken => {
                const clone = req.clone();
                return next.handle(this.checkAuth(clone, newToken));
              }),
              catchError((refreshError: HttpErrorResponse) => {
                const logoutErrors = [
                  'NotAuthorizedException',
                  'RefreshTokenReuseException',
                  'UserNotFoundException'
                ];

                const errorType = refreshError.error?.__type;
                const shouldLogout = refreshError.status === 401 ||
                  (refreshError.status === 400 && logoutErrors.includes(errorType));

                if (shouldLogout) {
                  this.authService.logout();
                }

                return throwError(() => refreshError);
              })
            );
          }

          return throwError(() => error);
        })
      );
    })
  );
}

  private checkAuth(req: HttpRequest<any>, token: any) {
    let authReq
    if(req.url.includes('amazoncognito.com/oauth2/token')) {
      // If client secret is empty then we are on prod, and we do not need to add basic auth to the header
      if(environment.clientSecret !== '') {
        authReq = req.clone({
          headers: req.headers
            .set('authorization', 'Basic ' + btoa(`${environment.clientId}:${environment.clientSecret}`))
            .set('content-type', 'application/x-www-form-urlencoded')
            .set('Access-Control-Allow-Origin', '*')
            .set('Access-Control-Allow-Headers', '*'),
        });
      } else {
        authReq = req.clone({
          headers: req.headers
            .set('content-type', 'application/x-www-form-urlencoded')
            .set('Access-Control-Allow-Origin', '*')
            .set('Access-Control-Allow-Headers', '*'),
        });
      }
    }
    else if (localStorage.getItem('__OVERRIDE_USER') != null && !(req.body instanceof FormData)) {
      authReq = req.clone({
        headers: req.headers
          .set('authorization', `${token}`)
          .set('__OVERRIDE_USER', `${localStorage.getItem('__OVERRIDE_USER')}`)
          .set('content-type', 'application/x-www-form-urlencoded')
          .set('Access-Control-Allow-Origin', '*')
          .set('Access-Control-Allow-Headers', '*'),
      });
    } else if (req.body instanceof FormData) {
      authReq = req.clone({
        headers: req.headers
          .set('authorization', `${token}`)
          .set('Access-Control-Allow-Origin', '*')
          .set('Access-Control-Allow-Headers', '*'),
      });

      if (localStorage.getItem('__OVERRIDE_USER') != null) {
        authReq = req.clone({
          headers: authReq.headers.set('__OVERRIDE_USER', `${localStorage.getItem('__OVERRIDE_USER')}`)
        });
      }
    } else {
      authReq = req.clone({
        headers: req.headers
          .set('authorization', `${token}`)
          .set('content-type', 'application/x-www-form-urlencoded')
          .set('Access-Control-Allow-Origin', '*')
          .set('Access-Control-Allow-Headers', '*'),
      });

      if(environment.__auth_email != null) {
        authReq = req.clone({
          headers: req.headers
            .set('__auth_email', `${environment.__auth_email}`)
            .set('authorization', `${token}`)
            .set('content-type', 'application/x-www-form-urlencoded')
            .set('Access-Control-Allow-Origin', '*')
            .set('Access-Control-Allow-Headers', '*'),
        })
      }
    }
    return authReq
  }
}
